import { connect } from 'react-redux';
import { RegularNotification } from './regular-notification';
import { getContactItemById } from 'shared/store/selectors/contact.selector';
import { useMemo } from 'react';
import { COMMUNICATIONS_TYPES } from 'shared/constants';
import { QualityMetricNotification } from './quality-metric-notification';

const mapStateToProps = ({ application, lang, contacts, usersManagement }, { sentBy }) => ({
  adminMode: application.adminMode,
  lang: lang.NEWS_FEED,
  user: getContactItemById({ contacts, usersManagement }, sentBy),
});

const NewsFeedItemComponent = ({ ...props }) => {
  const renderByType = useMemo(
    () =>
      new Map([
        [COMMUNICATIONS_TYPES.REGULAR, RegularNotification],
        [COMMUNICATIONS_TYPES.QUALITY, QualityMetricNotification],
      ]),
    [],
  );

  if (!renderByType.has(props.type)) {
    // Fallback to regular notification if type is not recognized
    return <RegularNotification {...props} />;
  }

  const Component = renderByType.get(props.type);

  return <Component {...props} />;
};

export const NewsFeedItem = connect(mapStateToProps)(NewsFeedItemComponent);
